/**
 * Centralised TanStack Query keys. Never inline an array literal as a key —
 * invalidation depends on these being the single source of truth.
 */
export const QUERY_KEYS = {
  viewer: () => ['viewer'] as const,
  sidebar: () => ['sidebar'] as const,
  notificationCounts: () => ['notifications', 'counts'] as const,
  commandSuggestions: (query: string) => ['command-palette', 'suggestions', query] as const,
} as const;
